import { Checkbox } from "@mui/material";
import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogPourbackReason } from "../../../models/CatalogPourbackReason";
import { useCatalogPourbackContext } from "../context/CatalogPourbackContext";

type Props = {
  setPourback: (pourback: CatalogPourbackReason) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
  onToggleEnabled: (pourback: CatalogPourbackReason) => void;
};

const EnabledCellRenderer = (
  params: ICellRendererParams & {
    onToggle: (pourback: CatalogPourbackReason) => void;
  },
) => (
  <Checkbox
    checked={!!params.value}
    color="primary"
    onClick={(e) => e.stopPropagation()}
    onDoubleClick={(e) => e.stopPropagation()}
    onChange={() => params.onToggle(params.data as CatalogPourbackReason)}
  />
);

export const useTableData = ({
  setPourback,
  setShowModal,
  showContextMenu,
  onToggleEnabled,
}: Props) => {
  const { state } = useCatalogPourbackContext();

  const rows: CatalogPourbackReason[] =
    state.pourbackReasons?.map((pourback: CatalogPourbackReason) => ({
      ...pourback,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "PourbackReasonName",
      headerName: "Reason",
      minWidth: 20,
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      sortable: false,
      filter: false,
      cellRenderer: EnabledCellRenderer,
      cellRendererParams: { onToggle: onToggleEnabled },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setPourback,
        data: params.data as CatalogPourbackReason,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "pourbackContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
